<template>
    <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
        <div
            v-if="image1"
            data-animation="FADE_UP"
            class="inline-block w-full md:col-span-2"
        >
            <img
                class="w-full h-full object-cover max-h-[600px] rounded-lg"
                :src="`${runtimeConfig.public.contentApiUrl}/assets/${image1.directus_files_id}?width=1536&height=600&quality=90&format=webp`"
                alt=""
            />
        </div>
        <div v-if="image2" data-animation="FADE_UP" class="inline-block w-full">
            <img
                class="w-full h-full object-cover max-h-[400px] rounded-lg"
                :src="`${runtimeConfig.public.contentApiUrl}/assets/${image2.directus_files_id}?width=750&height=400&quality=90&format=webp`"
                alt=""
            />
        </div>
        <div v-if="image3" data-animation="FADE_UP" class="inline-block w-full">
            <img
                class="w-full h-full object-cover max-h-[400px] rounded-lg"
                :src="`${runtimeConfig.public.contentApiUrl}/assets/${image3.directus_files_id}?width=750&height=400&quality=90&format=webp`"
                alt=""
            />
        </div>
    </div>
</template>

<script setup lang="ts">
// Config
const runtimeConfig = useRuntimeConfig();

// Props
const props = defineProps({
    image1: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    image2: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    image3: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});
</script>
